import { render, staticRenderFns } from "./InputBasic.vue?vue&type=template&id=e00acb7e"
import script from "./InputBasic.vue?vue&type=script&lang=js"
export * from "./InputBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports